/**
 * DE Studio feature flags + binding constants.
 * Per A-0012.02 SPEC §2.1 + UF-15 (Common Org locked).
 */

const env = (typeof process !== 'undefined' && process.env) || {};

// Master flag for the new DE Studio shell. OFF by default in prod, ON elsewhere.
export const DE_STUDIO_ENABLED = (
    env.REACT_APP_DE_STUDIO_ENABLED === 'true'
    || env.NODE_ENV !== 'production'
);

// Common Org for blueprints (UF-15). Read-only from any other org's perspective.
// Blueprint deploy deep-copies the chosen assistant + every referenced artifact
// into the user's own (org, sub) with new IDs.
// Env names match what the Dockerfile + pipelines already wire (from GitHub
// environment vars), so the per-env values actually reach the build.
export const COMMON_ORG_ID = env.REACT_APP_COMMON_ORGANIZATION_ID || '6966e70a4eddc106a9ed7901';
export const COMMON_SUB_ORG_ID = env.REACT_APP_COMMON_SUB_ORGANIZATION_ID || '6966e7274eddc106a9ed790a';

// OpCode inline editor defaults to Simple mode (hide advanced schema sections).
export const DE_STUDIO_OPCODE_SIMPLE_DEFAULT = (
    env.REACT_APP_DE_STUDIO_OPCODE_SIMPLE_DEFAULT !== 'false'
);
